import type { UtIdProvider } from '@unitedtraders/utex-site-common';

declare global {
  interface Window {
    pdst: any;
  }
}

const WAIT_LOADING = 500;
const MAX_ATTEMPTS = 10;

interface LeadParams {
  value?: string;
  currency?: string;
  category?: string;
  type?: string;
}

export class PodsightsApi {
  constructor(private window: Window, private utIdProvider: UtIdProvider) {}

  static isAvailable() {
    return window.pdst !== undefined;
  }

  aliasWithUtClientId = async () => {
    const utId = await this.utIdProvider.getId();
    this.window.pdst('alias', { id: utId });
  };

  lead = ({ value = '', currency = '', category = '', type = '' }: LeadParams) => {
    this.window.pdst('lead', {
      category,
      type,
      value,
      currency
    });
  };
}

export function podsightsProvider(
  window: Window,
  utIdProvider: UtIdProvider
): Promise<PodsightsApi> {
  if (PodsightsApi.isAvailable()) {
    return Promise.resolve(new PodsightsApi(window, utIdProvider));
  }

  return new Promise((resolve, reject) => {
    let tick = 0;
    const interval = setInterval(() => {
      tick += 1;

      if (PodsightsApi.isAvailable()) {
        clearInterval(interval);
        resolve(new PodsightsApi(window, utIdProvider));
      }

      if (tick > MAX_ATTEMPTS) {
        clearInterval(interval);
        reject(new Error('Can`t load podsight api'));
      }
    }, WAIT_LOADING);
  });
}
